import React from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { LoadingSpinner } from './ui/LoadingSpinner';

const GlobalLoadingBar: React.FC = () => {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50" style={{ height: '3px' }}>
      {/* Progress bar */}
      <div className="h-full bg-secondary-900 dark:bg-white animate-progress-bar"
           style={{
             animation: 'progress 1.5s ease-in-out infinite',
             transformOrigin: 'left'
           }} />

      {/* Loading message (optional) */}
      {loadingMessage && (
        <div className="absolute top-3 right-4 bg-secondary-900 dark:bg-secondary-800 text-white text-xs px-3 py-1.5 rounded-full shadow-lg flex items-center space-x-2">
          <LoadingSpinner size="xs" color="white" />
          <span>{loadingMessage}</span>
        </div>
      )}

      <style>{`
        @keyframes progress {
          0% {
            transform: scaleX(0);
          }
          50% {
            transform: scaleX(0.7);
          }
          100% {
            transform: scaleX(1);
          }
        }
      `}</style>
    </div>
  );
};

export default GlobalLoadingBar;